import React, { FC, useEffect, useState } from "react";
import SectionHeader from "../molecules/SectionHeader";
import MainLayout from "../../Layouts/MainLayout";
import { useNavigate } from "react-router-dom";
import RoleList from "../molecules/RoleList";
import { format, parseISO } from 'date-fns';
import Spinner from "../atoms/Spinner";
import { service } from "../../../services/AxiosServices";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
// Fetches and displays a list of roles with their details such as name, updated date,
//  and creator; allows creating new roles and deleting existing ones.

interface RoleDetails{
    id:number;
    name:string;
    updatedOn: string;
    createdBy: string;
}
const RoleDetails: FC = () => {
  const [roleDetails, setRoleDetails] = useState<RoleDetails[]>([]);
  const [loading,setLoading] = useState<boolean>(false)
  const accessCheckLoading = useAccessCheckLoading()

  useEffect(()=>{
     const listRoles = async()=>{
      try{
        setLoading(true)
        const token = localStorage.getItem('token')
         const response = await  service<{response:any}>(`/role-with-permissions`,'post'
           
         )
        setRoleDetails(response?.data?.response.map((role:any)=>({
           id:role.id,
           name:role.name,
           updatedOn:format(parseISO(role.updated_at), 'dd-MM-yyyy, HH:mm'),
           createdBy: 'Admin'
        })))
      }
      catch(err){

      }
      finally{
        setLoading(false)
      }
     }
     listRoles();
  },[])
  const navigate = useNavigate();
  const handleCreate = () => {
    navigate("/roles");
  };
  const handleDeleteRole = (id: number) => {
    setRoleDetails((prevRoles) => prevRoles.filter((role) => role.id !== id));
  };
  return (
    <>
      <MainLayout>
    
     
        <SectionHeader  back = {true}title="Role details" onAdd={handleCreate} action="Create"  permissionName={"configurations"}permissionTypes={["create"]} />
        {loading ? 
        (<Spinner/>)
        :
        (   
           roleDetails.length > 0 ?
           <RoleList roles={roleDetails} onDelete = {handleDeleteRole}/>
           : 
           <p className="text-center">No roles are available</p>
        
      )}
  
      </MainLayout>
    </>
  );
};
export default RoleDetails;
